// Adapted from https://github.com/chakra-ui/chakra-ui/blob/v2/packages/components/src/toast/toast.tsx
import {
    Alert, AlertDescription, AlertTitle, Flex, IconButton, ToastProps, chakra,
} from '@chakra-ui/react';
import {
    faCheckCircle, faExclamationCircle, faExclamationTriangle, faTimes,
} from '@fortawesome/pro-regular-svg-icons';
import { FaIcon } from '../fa-icon';

function getAlertIcon(status: ToastProps['status']) {
    switch (status) {
        case 'error':
            return faExclamationCircle;
        case 'warning':
            return faExclamationTriangle;
        case 'success':
            return faCheckCircle;
        case 'info':
        default:
            return faExclamationCircle;
    }
}

function getToastColorScheme(status: ToastProps['status']) {
    switch (status) {
        case 'error':
            return 'danger';
        case 'warning':
            return 'warning';
        case 'success':
            return 'success';
        case 'info':
        default:
            return 'info';
    }
}

function Toast(props: ToastProps) {
    const {
        status,
        id,
        title,
        isClosable,
        onClose,
        description,
    } = props;

    const ids = id !== undefined
        ? {
            root: `toast-${id}`,
            title: `toast-${id}-title`,
            description: `toast-${id}-description`,
        }
        : undefined;

    return (
        <Alert
            addRole={false}
            status={status}
            id={ids?.root}
            variant="solid"
            alignItems="center"
            boxShadow="lg"
            py={3}
            textAlign="start"
            width="auto"
            colorScheme={getToastColorScheme(status)}
        >
            <Flex mr={4}>
                <FaIcon h="1.2em" w="1.2em" icon={getAlertIcon(status)} />
            </Flex>
            <chakra.div flex="1" maxWidth="100%" pr={4}>
                {title !== undefined && <AlertTitle id={ids?.title} fontWeight="medium">{title}</AlertTitle>}
                {description !== undefined && (
                    <AlertDescription id={ids?.description} display="block">
                        {description}
                    </AlertDescription>
                )}
            </chakra.div>
            {isClosable === true && (
                <Flex ml={2}>
                    <IconButton
                        aria-label="Close"
                        icon={<FaIcon icon={faTimes} />}
                        variant="link"
                        colorScheme={getToastColorScheme(status)}
                        onClick={onClose}
                        px={0}
                        pr={2}
                        minWidth={0}
                    />
                </Flex>
            )}
        </Alert>
    );
}

export { Toast };
